import { RejectAssignmentRequestSchema, RejectAssignmentResponseSchema } from './reject-assignment.schema';
/**
 * Reject Assignment Endpoint Contract
 * Rejects a process step assignment
 * User can mark it as unclear or reassign to another user
 */ export const rejectAssignmentContract = {
    method: 'POST',
    path: '/api/v2/process-step-assignment/:id/reject',
    description: 'Reject a process step assignment with reason and optional reassignment',
    requestSchema: RejectAssignmentRequestSchema,
    responseSchema: RejectAssignmentResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body, assignment not found, or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user cannot reject this assignment'
        }
    }
};

//# sourceMappingURL=reject-assignment.contract.js.map